// Empty in dev (Vite proxies /api → 127.0.0.1:8787). Set in .env.production
// to the deployed Worker origin (e.g. https://linyuan-api.<sub>.workers.dev).
export const API_BASE = import.meta.env.VITE_API_BASE ?? '';
